import React from 'react'

export default function adminIntegration() {
  return (
    <div>
      adminIntegration
    </div>
  )
}
